export default __webpack_public_path__ + "static/media/webflower.374c9e48.png";